'use client'

// src/constants/cookies.ts
var COOKIE_TOKEN = "token";
var COOKIE_REFRESH_TOKEN = "refresh_token";
var COOKIE_TOKEN_EXPIRES_IN = "token_expires_in";

export {
  COOKIE_TOKEN,
  COOKIE_REFRESH_TOKEN,
  COOKIE_TOKEN_EXPIRES_IN
};
//# sourceMappingURL=chunk-5KF4VIOG.mjs.map